import { useState } from 'react';
import SettingsContainer from './SettingsContainer';
import { getDisplayStatus } from '../util';
import StatusHeader from './StatusHeader';
import { deleteKioskAttractor, updateKioskAttractor } from '../../api/new-api';
import { useColors } from '../../provider/colors-provider';

const AttractorImageSettingsContainer = ({ d, getAttractors }: any) => {
  const { primary } = useColors();
  const [openSettings, setOpenSettings] = useState(false);

  const currentTime = Date.now();

  const attractorWithStatus = getDisplayStatus(d, currentTime);

  const handleDelete = async (attractorId: string | number) => {
    await deleteKioskAttractor({ attractorId });
    await getAttractors();
  };

  const handleUpdate = async (data: {
    startDate: string;
    endDate: string;
    selected: any[];
  }) => {
    const attractor = {
      startDateEpoch: new Date(data.startDate).getTime(),
      endDateEpoch: new Date(data.endDate).getTime(),
      dayVisibility: data.selected.map((val: any) => val.value).join(','),
      attractorId: d.attractorId,
    };

    await updateKioskAttractor({ ...attractor });
    await getAttractors();
  };

  const isMp4 = d.imageUrl.includes('.mp4');

  return (
    <div className="max-w-sm bg-white border border-gray-200 rounded-2xl shadow dark:bg-gray-800 dark:border-gray-700">
      <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
        <StatusHeader
          displayStatus={attractorWithStatus.displayStatus}
          dayDifference={attractorWithStatus.dayDifference}
        />
      </p>
      <div className="p-5">
        {isMp4 ? (
          <video
            className="w-full object-cover rounded-lg"
            src={d.imageUrl}
            autoPlay
            loop
            muted
          />
        ) : (
          <img
            className="rounded-t-lg"
            src={d.imageUrl}
            alt={`attractor image url`}
          />
        )}
      </div>
      <div className="p-5">
        {openSettings ? (
          <SettingsContainer
            openSettings={openSettings}
            setOpenSettings={setOpenSettings}
            data={d}
            hideCloseButton={false}
            hideDeleteButton={false}
            handleSubmit={handleUpdate}
            handleDelete={handleDelete}
            handleClose={() => null}
          />
        ) : (
          <p
            onClick={() => {
              setOpenSettings(!openSettings);
            }}
            className="hover:opacity-70 hover:cursor-pointer inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-primary-700 rounded-lg hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300"
            style={{
              backgroundColor: primary,
            }}
          >
            Settings
            <svg
              className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 10"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M1 5h12m0 0L9 1m4 4L9 9"
              />
            </svg>
          </p>
        )}
      </div>
    </div>
  );
};

export default AttractorImageSettingsContainer;
